/**
 *  @author:        Cloud for Good
 *  @description:   Builds the pdpTestimonials.js file including necessary components.
 *
 *  History
 *  <Date>        <Author Name>       <Reference #>       <Change Description>
 *  2024-05-30    Julie Branyan       CFG-215              Initial creation
*/

'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/pdpTestimonials'));
});
